<template>
  <v-card class="search-pill mx-auto" flat>
  <v-row align="center" class="pill-row px-6 justify-space-between">
      <!-- Departing Between -->
      <v-col cols="12" md="4" class="d-flex align-center">
        <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y>
          <template #activator="{ props }">
            <v-text-field v-bind="props" v-model="displayDateRange" placeholder="Departing between"
              persistent-placeholder prepend-inner-icon="mdi-calendar" variant="plain" hide-details
              class="ghost-field w-100" readonly />
          </template>
          <v-card class="pa-2">
            <VueDatePicker v-model="selectedRange" :range="true" :multi-calendars="2" :enable-time-picker="false"
              :auto-apply="true" :teleport="false" :inline="true" /> <v-btn block color="primary" class="mt-2"
              @click="dateMenu = false">Done</v-btn>
          </v-card>
        </v-menu>
      </v-col>

      <!-- Divider -->
      <v-divider class="pill-divider d-none d-md-flex" vertical />

      <!-- Duration -->
      <v-col cols="12" md="4" class="d-flex align-center">
        <v-menu v-model="durationMenu" :close-on-content-click="false" offset-y>
          <template #activator="{ props }">
            <v-text-field v-bind="props" v-model="durationDisplay" placeholder="Duration" persistent-placeholder
              prepend-inner-icon="mdi-clock-time-eight-outline" variant="plain" hide-details class="ghost-field w-100" readonly />
          </template>
          <v-card class="pa-4" style="min-width: 300px;"> <v-row dense> <v-col cols="6"> <v-text-field
                  v-model.number="minNights" type="number" label="Min nights" variant="outlined" density="comfortable"
                  hide-details /> </v-col> <v-col cols="6"> <v-text-field v-model.number="maxNights" type="number"
                  label="Max nights" variant="outlined" density="comfortable" hide-details /> </v-col> </v-row> <v-btn
              color="primary" block class="mt-2" @click="durationMenu = false">Done</v-btn> </v-card>
        </v-menu>
      </v-col>

      <!-- Search -->
      <v-col cols="12" md="2" class="d-flex justify-end">
        <v-btn class="search-btn" color="primary" rounded="pill" height="44" @click="handleSearch">
          Search
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>


<script setup>
import { ref, computed } from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker'

const selectedRange = ref(null)
const dateMenu = ref(false)
const durationMenu = ref(false)
const minNights = ref(3)
const maxNights = ref(9)

const durationDisplay = computed(() =>
  minNights.value && maxNights.value ? `${minNights.value} – ${maxNights.value} nights` : ''
)

const displayDateRange = computed(() => {
  if (!selectedRange.value || !selectedRange.value.length) return ''
  const [start, end] = selectedRange.value
  return `${formatDate(start)} – ${formatDate(end)}`
})

function formatDate(date) {
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    .format(new Date(date))
}

const handleSearch = () => {
  console.log('Search triggered with:', {
    range: selectedRange.value,
    minNights: minNights.value,
    maxNights: maxNights.value
  })
}
</script>

<style scoped>
/* Pill container: exact height + center contents */
.search-pill {
  background: #fff;
  border-radius: 999px;
  margin-left: auto;
  margin-right: auto;

  /* fluid but not full-width */
  width: clamp(300px, 92vw, 960px);  
  max-width: 960px;

  height: 80px;
  display: flex;
  align-items: center;
  box-shadow:
    0 8px 24px rgba(23, 35, 84, 0.18),
    inset 0 0 0 3px rgba(255, 255, 255, 0.9);
  padding-inline: 12px;
}

/* Row fills pill and centers items */
.pill-row {
  min-height: 80px;
}

/* Remove field chrome and size inputs to sit centered */
.ghost-field :deep(.v-field) {
  background: transparent !important;
  box-shadow: none !important;
  height: 50px;
  /* ~80 pill minus padding looks centered */
  align-items: center;
}

.ghost-field :deep(.v-field__outline) {
  display: none !important;
}

.ghost-field :deep(.v-field__input) {
  display: flex;
  align-items: center;
  padding-block: 0;
  font-weight: 600;
  color: #6b767b;
}

.ghost-field :deep(.v-field__prepend-inner .v-icon) {
  font-size: 22px;
  margin-right: 10px;
  color: #6b767b;
}

/* Short divider, centered vertically */
.pill-divider {
  height: 40px !important;
  /* not full height */
  align-self: center;
  opacity: 0.25;
  margin-inline: 6px;
}

/* Button */
.search-btn {
  padding-inline: 24px;
  font-weight: 800;
  letter-spacing: .3px;
}
</style>
